import React from "react";

import ReleaseLabel from "../../ReleaseLabel";

interface DynamicReleaseLabelProps {
  label: {
    id: number;
    name: string;
  };
  onClick: (id: number) => void;
}

const DynamicReleaseLabel: React.FC<DynamicReleaseLabelProps> = ({ label, onClick }) => (
  <ReleaseLabel
    label={label}
    variant="dynamic"
    onClick={l => onClick(l.id)}
    readOnly={false}
    showDeleteButton={false}
  />
);

export default DynamicReleaseLabel;
